import React from 'react'
import MobileForgotPassword from '../../mobileView/forgotPassword/MobileForgotPassword'

const MobForgotPassword = () => {
  return (
    <div>
        <MobileForgotPassword />
    </div>
  )
}

export default MobForgotPassword